import { useStaticQuery, graphql } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const useSolutionSellPageContent = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: solutionSellPageContentJson {
        benefits {
          solution_benefits {
            data {
              description
              headline {
                html
              }
              list {
                text
              }
            }
          }
        }
        header {
          description
          caption
          headline {
            html
          }
          image {
            alt
            image {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG)
              }
            }
          }
        }
      }
      de: deSolutionSellPageContentJson {
        benefits {
          solution_benefits {
            data {
              description
              headline {
                html
              }
              list {
                text
              }
            }
          }
        }
        header {
          description
          caption
          headline {
            html
          }
          image {
            alt
            image {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG)
              }
            }
          }
        }
      }
    }
  `);

  return data[locale];
};
